import styled from 'styled-components';

const ResolveButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: ${({ $compact }) => ($compact ? '2px 8px' : '6px 14px')};
  font-size: ${({ $compact }) => ($compact ? '12px' : '13px')};
  font-weight: 400;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey2};
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.grey1};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default ResolveButton;
